import { useEffect } from "react";

const SelectThoroughfare = ({ thoroughfares, selectedThoroughfare, setSelectedThoroughfare, disabled }) => {
    useEffect(() =>{
        if (thoroughfares.length > 0) {
            setSelectedThoroughfare(thoroughfares[0].name)
        }
    }, [thoroughfares])
    return (
        <select
        disabled={disabled}
        id='place-select'
        className='choice-select'
        value={selectedThoroughfare}
        onChange={(e) => setSelectedThoroughfare(e.target.value)}
        >
            {selectedThoroughfare === '' ? <option value="">
                ------
            </option> : null}
            {thoroughfares && thoroughfares.map((thoroughfare) => (
                <option
                    key={thoroughfare.id}
                    value={thoroughfare.name}
                >
                    {thoroughfare.name}
                </option>
            ))}
        </select>
    );
};

export default SelectThoroughfare;